module.exports = __webpack_public_path__ + "img/115.physical_conditions.73b42b76.svg";